import * as Localization from 'expo-localization';

/**
 * Known locales
 */
export const Known = ['es', 'en'];

/**
 * Gets current locale, and if it is not one of the accepted it falls backs to english
 */
function getLocale(): string {
  const locale = Localization.locale.substr(0, 2);
  const customLocale = locale === 'ca' ? 'es' : locale;
  return Known.includes(customLocale) ? customLocale : 'en';
}

const Language = {
  locale: (): string => getLocale()
};

export default Language;
